<template>
    <Top />
    <!-- Spinner Start -->
    <!-- Spinner Start -->
    <div id="spinner" style="background-color: #DCDCDC;z-index: 999999;opacity: 0.5;" v-if="halamanloading"
        class="show position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <img src="../../../../src/assets/images/logo.png" height="40">&nbsp;
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
        </div>
        &nbsp;<span class="sr-only text-danger" style="font-weight: bolder;">..CISP System Loading...</span>
    </div>
    <!-- Spinner End -->
    <section class="hero-section d-flex justify-content-center align-items-center" id="section_1"
        :style="'background-image:url(' + folder_slider + foto_background + ') !important;'">
        <div class="section-overlay"></div>
        <svg xmlns="" viewBox="0 5 1440 320">
            <rect x="0" y="0" width="2980" height="100" fill="#3D405B" />
        </svg>
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-12 mb-5 mb-lg-0">
                    <h5 class="text-white">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">{{ namaku }}&nbsp;</span>
                        <span v-else>{{ nama_eng }}&nbsp;</span>
                    </h5>
                    <h1 class="cd-headline rotate-1 text-white mb-4 pb-2">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">{{ text_label }}&nbsp;</span>
                        <span v-else>{{ text_label_eng }}&nbsp;</span>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')" class="cd-words-wrapper">
                            <template v-for="(dataketerangan, urutketerangan) in keterangan" :key="urutketerangan">
                                <b :class="[((urutketerangan == 0) ? 'is-visible' : '')]">{{ dataketerangan.nama }}</b>
                            </template>
                        </span>
                        <span v-else class="cd-words-wrapper">
                            <template v-for="(dataketerangan_eng, urutketerangan_eng) in keterangan_eng"
                                :key="urutketerangan_eng">
                                <b :class="[((urutketerangan_eng == 0) ? 'is-visible' : '')]">{{ dataketerangan_eng.nama
                                    }}</b>
                            </template>
                        </span>
                    </h1>
                </div>
            </div>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fill-opacity="1"
                d="M0,224L34.3,192C68.6,160,137,96,206,90.7C274.3,85,343,139,411,144C480,149,549,107,617,122.7C685.7,139,754,213,823,240C891.4,267,960,245,1029,224C1097.1,203,1166,181,1234,160C1302.9,139,1371,117,1406,106.7L1440,96L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z">
            </path>
        </svg>
    </section>
    <section class="about-section">
        <div class="container">
            <div class="row g-4 justify-content-center">
                <p>&nbsp;</p>
            </div>
            <div class="row g-4 justify-content-center">
                <p>&nbsp;</p>
            </div>
            <div class="row g-4 justify-content-center">
                <h3 class="cd-headline rotate-1 mb-4 pb-2">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Grafik OWP, AWP, Disbursement Plan dan
                        Realiasi</span>
                    <span v-else>OWP, AWP, Disbursement Plan and Realization Graphs</span>
                </h3>
                <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s"
                    style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                    <LineChartMonitoringProyek type="line" :options="chartOptionsmonitoring" :series="seriesmonitoring"
                        height="500">
                    </LineChartMonitoringProyek>
                </div>
            </div>
            <div class="row g-4 justify-content-center">
                <p>&nbsp;</p>
            </div>
            <div class="row g-4 justify-content-center">
                <h3 class="cd-headline rotate-1 mb-4 pb-2">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Daftar OWP, AWP, Disbursement Plan dan
                        Realiasi</span>
                    <span v-else>List of OWP, AWP, Disbursement Plan and Realization</span>
                </h3>
                <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="table-responsive table-wrapper">
                        <table class="table m-0" id="tabeldataprogres" style="font-size: small;">
                            <thead>
                                <tr>
                                    <th style="width: 50px;" rowspan="2">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            No
                                        </span>
                                        <span v-else>
                                            No
                                        </span>
                                    </th>
                                    <th style="width: 50px;" rowspan="2">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Kode Satker
                                        </span>
                                        <span v-else>
                                            Working Unit Code
                                        </span>
                                    </th>
                                    <th style="width: 350px;" rowspan="2">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            PIU / Paket Pekerjaan
                                        </span>
                                        <span v-else>
                                            Implementing Unit / Work Packages
                                        </span>
                                    </th>
                                    <th style="width: 50px;" rowspan="2">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            OWP
                                        </span>
                                        <span v-else>
                                            OWP
                                        </span>
                                    </th>
                                    <th style="width: 50px;" :colspan="colspan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            AWP
                                        </span>
                                        <span v-else>
                                            AWP
                                        </span>
                                    </th>
                                    <th style="width: 50px;" :colspan="colspan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Disbursement Plan
                                        </span>
                                        <span v-else>
                                            Disbursement Plan
                                        </span>
                                    </th>
                                    <th style="width: 50px;" :colspan="colspan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Realisasi
                                        </span>
                                        <span v-else>
                                            Realisasi
                                        </span>
                                    </th>
                                </tr>
                                <tr>
                                    <template v-for="(listtahun, uruttahun) in datatahun" :key="uruttahun">
                                        <th style="width: 50px;">
                                            {{ listtahun.tahun }}
                                        </th>
                                    </template>
                                    <template v-for="(listtahun, uruttahun) in datatahun" :key="uruttahun">
                                        <th style="width: 50px;">
                                            {{ listtahun.tahun }}
                                        </th>
                                    </template>
                                    <template v-for="(listtahun, uruttahun) in datatahun" :key="uruttahun">
                                        <th style="width: 50px;">
                                            {{ listtahun.tahun }}
                                        </th>
                                    </template>
                                </tr>
                            </thead>
                            <template v-for="(datalist, urutlist) in PIU" :key="urutlist">
                                <tbody>
                                    <tr>
                                        <td class="text-center" :class="datalist.class">
                                            {{ urutlist + 1 }}
                                        </td>
                                        <td class="text-center" :class="datalist.class">
                                            {{ datalist.kodesatker }}
                                        </td>
                                        <td class="text-left" :class="datalist.class">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                {{ datalist.nama }}
                                            </span>
                                            <span v-else>
                                                {{ datalist.nama_eng }}
                                            </span>
                                        </td>
                                        <td class="text-right" :class="datalist.class">
                                            {{ G_numFormat(datalist.OWP) }}
                                        </td>
                                        <td class="text-right" :class="datalist.class"
                                            v-for="(dataAWP, urutAWP) in datalist.AWP" :key="urutAWP">
                                            {{ G_numFormat(dataAWP.AWP) }}
                                        </td>
                                        <td class="text-right" :class="datalist.class"
                                            v-for="(dataDISBURSEMENT, urutDISBURSEMENT) in datalist.DISBURSEMENT"
                                            :key="urutDISBURSEMENT">
                                            {{ G_numFormat(dataDISBURSEMENT.DISBURSEMENT) }}
                                        </td>
                                        <td class="text-right" :class="datalist.class"
                                            v-for="(dataREALISASI, urutREALISASI) in datalist.REALISASI"
                                            :key="urutREALISASI">
                                            {{ G_numFormat(dataREALISASI.REALISASI) }}
                                        </td>
                                    </tr>
                                    <tr v-for="(datadetail, urutdetail) in datalist.detail" :key="urutdetail">
                                        <td>
                                            {{ urutlist + 1 }}.{{ urutdetail + 1 }}
                                        </td>
                                        <td colspan="2">
                                            {{ datadetail.Nama_Kegiatan }}
                                        </td>
                                        <td class="text-right">
                                            {{ G_numFormat(datadetail.OWP) }}
                                        </td>
                                        <template v-for="(datadetailnya, urutdetailnya) in datadetail.detailnya"
                                            :key="urutdetailnya">
                                            <td class="text-right">
                                                {{ G_numFormat(datadetailnya.AWP) }}
                                            </td>
                                            <td class="text-right">
                                                {{ G_numFormat(datadetailnya.DISBURSEMENT) }}
                                            </td>
                                            <td class="text-right">
                                                {{ G_numFormat(datadetailnya.REALISASI) }}
                                            </td>
                                        </template>
                                    </tr>
                                </tbody>
                            </template>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import 'vue3-carousel/dist/carousel.css'
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, DonutsChartMonitoringProyek: VueApexCharts
        , DonutsChartMonitoringWaktuProyek: VueApexCharts, DonutsChartMonitoringPVProyek: VueApexCharts
        , LineChartMonitoringProyek: VueApexCharts, BarChartMonitoringPVProyek: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            datatahun: [],
            totalowp: 0,
            totalawp: 0,
            sisapagu: 0,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            project_id: process.env.VUE_APP_PROJECT_ID,
            tanggalsinkron: new Date(),
            tanggaldatamonev: new Date(),
            dataproyek: [],
            seriesproyek: [],
            chartOptionsproyek: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'Poppins-SemiBold, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                name: {
                                    formatter: function (value) {
                                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                    },
                                },
                                value: {
                                    formatter: function (val) {
                                        return (val / 1000000000).toFixed(0).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' M';
                                    }
                                },
                                total: {
                                    formatter: function (w) {
                                        let setTotal = w.globals.seriesTotals.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
                                        let val = (setTotal / 1000000000000).toFixed(2).replace('.', ',')
                                        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' T'
                                    },
                                    show: true,
                                },
                            }
                        }
                    }
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datawaktu: [],
            serieswaktu: [],
            chartOptionswaktu: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'Poppins-SemiBold, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                name: {
                                    formatter: function (value) {
                                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                    },
                                },
                                value: {
                                    formatter: function (val) {
                                        return (val / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' Bulan';
                                    }
                                },
                                total: {
                                    formatter: function (w) {
                                        let setTotal = w.globals.seriesTotals.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
                                        let val = (setTotal / 1).toFixed(2).replace('.', ',')
                                        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' Bulan'
                                    },
                                    show: true,
                                },
                            }
                        }
                    }
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datapv: [],
            seriespv: [],
            chartOptionspv: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'Poppins-SemiBold, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datamonitoring: [],
            seriesmonitoring: [],
            chartOptionsmonitoring: {
                chart: {
                    width: '100%',
                    height: 450,
                    type: 'line',
                    zoom: {
                        type: 'x',
                        enabled: true,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        autoSelected: 'zoom'
                    }
                },
                colors: ['#00CED1', '#FFD700', '#9370DB', '#4682B4', '#32CD32'],
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: 'Grafik OWP AWP',
                    align: 'center'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: ''
                    }
                },
                yaxis: {
                    title: {
                        text: ''
                    },
                },
                legend: {
                    position: 'bottom',
                    floating: true,
                    offsetY: -10,
                    offsetX: -5,
                    show: true,
                }
            },

            series_newpv: [{
                data: []
            }],
            chartOptions_newpv: {
                plotOptions: {
                    bar: {
                        barHeight: '100%',
                        distributed: true,
                        horizontal: true,
                        dataLabels: {
                            position: 'bottom'
                        },
                    }
                },
                colors: [],
                dataLabels: {
                    enabled: true,
                    textAnchor: 'start',
                    style: {
                        colors: ['#fff']
                    },
                    formatter: function (val, opt) {
                        return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
                    },
                    offsetX: 0,
                    dropShadow: {
                        enabled: true
                    }
                },
                stroke: {
                    width: 1,
                    colors: ['#fff']
                },
                xaxis: {
                    categories: ['PV'],
                },
                yaxis: {
                    labels: {
                        show: false
                    }
                },
                title: {
                    text: 'Progress Variant',
                    align: 'center',
                    floating: true
                },

                tooltip: {
                    theme: 'dark',
                    x: {
                        show: false
                    },
                    y: {
                        title: {
                            formatter: function () {
                                return ''
                            }
                        }
                    }
                }
            },

            namaku: '',
            nama_eng: '',
            text_label: '',
            text_label_eng: '',
            keterangan: [],
            keterangan_eng: [],
            folder_slider: process.env.VUE_APP_URL_API + 'parastapainnovation_slider-Gambar?f=',
            foto_background: '',
            PIU: [],
            colspan: 0,
        };
    },
    methods: {
        async ambildata() {
            const mainAPI3 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

            this.halamanloading = true;
            var random = Math.random();
            await mainAPI3.get("parastapainnovation-GetSlider?random=" + random + "&project_id=" + this.project_id + "&id=14").then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataslider = [];
                        this.dataslider = Response.data.content.data;
                        this.namaku = Response.data.content.data[0].nama;
                        this.nama_eng = Response.data.content.data[0].nama_eng;
                        this.text_label = Response.data.content.data[0].text_label;
                        this.text_label_eng = Response.data.content.data[0].text_label_eng;
                        this.keterangan = Response.data.content.data[0].keterangan;
                        this.keterangan_eng = Response.data.content.data[0].keterangan_eng;
                        this.foto_background = '';
                        this.foto_background = Response.data.content.data[0].filenya_slider;
                        this.halamanloading = false;
                    }
                    else {
                        this.dataslider = [];
                        this.foto_background = '';
                        this.halamanloading = false;
                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.foto_background = '';
                this.dataslider = [];
                this.halamanloading = false;
            });

            this.halamanloading = true;
            this.PIU = [];
            this.colspan = 0;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoring-Finance?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataproyek = [];
                        this.seriesproyek = [];

                        this.chartOptionsproyek = {
                            labels: []
                        };
                        this.dataproyek = Response.data.content.data;
                        this.PIU = this.dataproyek[0].PIU;
                        this.colspan = this.dataproyek[0].Tahun.length;
                        this.tanggalsinkron = this.dataproyek[0].TanggalSinkronisasi;
                        this.tanggaldatamonev = this.dataproyek[0].TanggalDataMonev;
                        this.datamaster = this.dataproyek[0].OWP;
                        this.datatahun = this.dataproyek[0].Tahun;
                        this.totalawp = this.dataproyek[0].AWPTOTAL;
                        this.sisapagu = this.dataproyek[0].SISAPAGUTOTAL;
                        try {
                            this.totalowp = this.datamaster.reduce((a, { OWP: e }) => a + e, 0);
                        } catch (error) {

                        }

                        //alert(this.totalowp);
                        var texttrilliyun = '';
                        var textrealisasi = '';
                        var textjudul = '';
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            texttrilliyun = 'Dalam Triliyun (Rp.)';
                            textrealisasi = 'Realisasi';
                            textjudul = 'Perbandingan OWP, AWP dan Realisasi Kumulatif Tahunan';
                            this.chartOptionsproyek.labels.push('Sudah dicairkan');
                            this.chartOptionsproyek.labels.push('Belum dicairkan');
                            this.chartOptionsproyek.title = {
                                text: 'Realisasi Pencairan Proyek',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };

                        }
                        else {
                            texttrilliyun = 'in Trilions (IDR)';
                            textrealisasi = 'Realization';
                            textjudul = 'Comparison of OWP, AWP and Annual Cumulative Realization';
                            this.chartOptionsproyek.labels.push('Disbursed');
                            this.chartOptionsproyek.labels.push('Undisbursed');
                            this.chartOptionsproyek.title = {
                                text: 'Realization of Project Disbursement',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            };
                        }

                        this.datamonitoring = [];
                        this.seriesmonitoring = [];
                        this.datamonitoring = Response.data.content.data;
                        var temptahun = [];
                        var tempowp = [];
                        var tempawp = [];
                        var tempspm = [];
                        var tempowpmonev = [];
                        var temprealisasimonev = [];
                        var tempdisbursementmonev = [];
                        for (let i = 0; i < this.dataproyek[0].Tahun.length; i++) {
                            temptahun.push(this.dataproyek[0].Tahun[i].tahun);
                            tempowp.push(this.dataproyek[0].Tahun[i].owptrilyun);
                            tempawp.push(this.dataproyek[0].Tahun[i].awptrilyun);
                            tempspm.push(this.dataproyek[0].Tahun[i].spmtrilyun);
                            tempowpmonev.push(this.dataproyek[0].Tahun[i].dataowpmonevtrilyun);
                            temprealisasimonev.push(this.dataproyek[0].Tahun[i].datarealisasimonevtrilyun);
                            tempdisbursementmonev.push(this.dataproyek[0].Tahun[i].datadisbursementmonevtrilyun);
                        }

                        this.seriesmonitoring.push(
                            {
                                name: "OWP",
                                data: tempowp
                            },
                            {
                                name: "AWP",
                                data: tempawp
                            },
                            {
                                name: textrealisasi,
                                data: temprealisasimonev
                            },
                            {
                                name: "Disbursement Plan",
                                data: tempdisbursementmonev
                            },
                        )
                        //alert(temptahun);
                        this.chartOptionsmonitoring = {
                            title: {
                                text: textjudul,
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'Poppins-SemiBold, Arial',
                                    color: '#263238'
                                },
                            },
                            xaxis: {
                                categories: temptahun,
                                offsetY: -20
                            },
                            yaxis: {
                                title: {
                                    text: texttrilliyun
                                },
                            },
                            legend: {
                                position: 'bottom',
                                floating: true,
                                offsetY: 0,
                                offsetX: 0,
                                show: true,
                            }
                        };


                    }
                    else {
                        this.PIU = [];
                        this.colspan = 0;
                        this.totalowp = 0;
                        this.datamonitoring = [];
                        this.seriesmonitoring = [];
                        this.datamaster = [];
                        this.dataproyek = [];
                        this.seriesproyek = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionsproyek = {
                            labels: []
                        };

                        this.datawaktu = [];
                        this.serieswaktu = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionswaktu = {
                            labels: []
                        };

                        this.datapv = [];
                        this.seriespv = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionspv = {
                            labels: []
                        };
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.totalowp = 0;
                this.datamaster = [];
                this.PIU = [];
                this.colspan = 0;
                this.datamonitoring = [];
                this.seriesmonitoring = [];
                this.dataproyek = [];
                this.seriesproyek = [];
                this.tanggalsinkron = new Date();
                this.chartOptionsproyek = {
                    labels: []
                };

                this.datawaktu = [];
                this.serieswaktu = [];
                this.tanggalsinkron = new Date();
                this.chartOptionswaktu = {
                    labels: []
                };

                this.datapv = [];
                this.seriespv = [];
                this.tanggalsinkron = new Date();
                this.chartOptionspv = {
                    labels: []
                };
                //console.log(error);
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style>
.carousel__prev,
.carousel__next {
    box-sizing: content-box;
    border: 5px solid #0055aa;
    border-radius: 40px;
    background-color: #0055aa;
    color: aliceblue;
    height: 50px;
    width: 50px;
}

/* The Modal (background) */
.modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 888888;
    /* Sit on top */
    padding-top: 20px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(251, 248, 248, 0.9);
    /* Fallback color */
    background-color: rgb(251, 248, 248, 0.9);
    /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    float: left;
    margin-right: 10px;
    margin-left: 60px;
}

/* Caption of Modal Image */
#caption {
    margin: auto;
    display: block;
    width: 90%;
    max-width: 90%;
    text-align: justify;
    color: #111;
    padding: 10px 0;
}

/* Add Animation */
.modal-content,
#caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
    from {
        -webkit-transform: scale(0)
    }

    to {
        -webkit-transform: scale(1)
    }
}

@keyframes zoom {
    from {
        transform: scale(0)
    }

    to {
        transform: scale(1)
    }
}

/* The Close Button */
.close {
    position: absolute;
    top: 20px;
    right: 35px;
    color: #111;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
    z-index: 99999;
}

.close:hover,
.close:focus {
    color: #111;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
    .modal-content {
        width: 100%;
    }
}

.gambar:hover {
    cursor: pointer;
    opacity: 0.5;
}
</style>